const COLORS = {
  white: '#ffffff',
  black: '#000000',
  old: {
    lightBorder: '#e2e5e7',
    footerText: '#dfe3e8',
    footerGradient: 'linear-gradient(100deg, #58646e, #404c57)'
  },
  background: {
    page: '#ffffff',
    main: '#f7f9fb',
    footer: '#292f34',
    footerNew: '#030a29',
    subFooter: '#454d55'
  },
  primary: '#3089f3',
  secondary: '#9dd0fb',
  tertiary: '#fbb032',
  success: '#71d77c',
  error: '#ed4949',
  ui: {
    inputBorder: '#cdcdcd',
    disabledBoxShadow: '#23293026',
  },
  text: {
    header: '#262626',
    label: '#4c5a64',
    formLabel: '#19191b',
    input: '#4c5a64',
    disabledInput: '#cccccc',
    inputPlaceholder: '#959da3',
    menuItem: '#414141',
    inputLightBackground: '#f2f3f5',
    subContent: '#6c6d6e',
    mainFooter: '#ffffff',
    subFooter: '#c5c7ca'
  }
}

export default COLORS
